import React from "react";
import { Spinner } from "react-bootstrap";
import { useUserService } from "../../../services/userService";
import { Collection, People, Sliders2 } from "react-bootstrap-icons";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Projects({
  handleCloseOffcanvas,
}: {
  handleCloseOffcanvas: () => void;
}) {
  const { user: data, loading } = useUserService();
  const projects = data?.domains || [];
  const lang = useGetUrlLocale();
  const { t } = useTranslation();
  if (loading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  return (
    <>
      {projects.slice(0, 4).map((project) => (
        <li
          className="nav-item w-100 ps-3 mb-2 d-flex justify-content-between align-items-center w-100"
          key={project.id}
        >
          <Link
            to={`${lang}/projects/${project.id}`}
            className={`nav-link pe-0 w-75 ${
              location.pathname.includes(`/projects/${project.id}`)
                ? "active"
                : ""
            }`}
            onClick={handleCloseOffcanvas}
          >
            <div className="d-flex align-items-center  overflow-hidden">
              <div>
                <Collection className="me-2" />
                <span>{project.title.slice(0, 30)}</span>
              </div>
            </div>
          </Link>
          <div className="d-flex">
            {project.userAccesses.length > 0 && (
              <People className="text-gray" />
            )}
            <Link
              to={`${lang}/projects/${project.id}/edit`}
              onClick={handleCloseOffcanvas}
              className="nav-link py-0 d-flex justify-content-between align-items-center"
            >
              <Sliders2 className="text-gray" />
            </Link>
          </div>
        </li>
      ))}
      {projects.length > 4 && (
        <li className="nav-item w-100 d-flex justify-content-center mb-2">
          <Link
            to={`${lang}/projects`}
            className="nav-link"
            onClick={handleCloseOffcanvas}
          >
            {t("menu.all")}
          </Link>
        </li>
      )}
    </>
  );
}
